import React from "react";
import styled from "styled-components";
import { defineMessages } from "react-intl";
import { FormattedMessage } from "components/FormattedMessage";
import { SpinningAnimation } from "./FormButton/SpinningAnimation";

const messages = defineMessages({
  button_message: {
    id: "shared.DownloadSMSForm.sms_button_text",
    defaultMessage: "Get the app",
  },
});

export function FormButton({ onClick, isLoading }) {
  return (
    <Button type="button" onClick={onClick}>
      {isLoading ? <SpinningAnimation /> : null}
      <FormattedMessage message={messages.button_message} />
    </Button>
  );
}

const Button = styled.button`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing.md};
  padding-top: ${(props) => props.theme.spacing.sm};
  padding-bottom: ${(props) => props.theme.spacing.sm};
  padding-left: ${(props) => props.theme.spacing.md};
  padding-right: ${(props) => props.theme.spacing.md};
  text-align: center;
  border: 0;
  border-radius: ${(props) => props.theme.layout.borderRadius.btn};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  color: ${(props) => props.theme.color.buttonTextPrimary};
  background-color: ${(props) => props.theme.color.buttonBackgroundPrimary};
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.color.buttonBackgroundPrimaryHover};
  }
  ${(props) => props.theme.breakpoints.tabletUp} {
    flex-grow: 1;
  }
`;
